<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <data-table :headings="depotProductHeadings" :data="depotProducts" :hasActions="true"
                            :pagingDetails="pagingDetails"
                            :stateChanged="filterStateChanged"
                            @pagingUpdated="onPagingUpdated"
                            @actionClicked="onProductActionClicked" @filterSearchClicked="onFilterSearchClicked">
                    <template #actionButton>
                        <div class="w-100">
                            <button class="btn btn-primary" @click="onManageProductsClick">Manage Products</button>
                        </div>
                    </template>
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="pb-4">
                                <label>Depots</label>
                                <bootstrap-select  :selectOptions="depots" :selectedOption="filter.depotId" :elementId="'depotFilterSelect'"
                                                   :returnSelectedOptionText="true"
                                                   @changeSelect="onDepotFilterSelect"></bootstrap-select>
                            </div>
                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                           :componentId="'depotFilterRadioButtons'"
                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="depotPricingMarkAsActiveInactiveModal.heading"
                :modalId="depotPricingMarkAsActiveInactiveModal.modalId"
                :isSaving="depotPricingMarkAsActiveInactiveModal.isSaving"
                :showModal="depotPricingMarkAsActiveInactiveModal.showModal"
                :isActive="depotPricingMarkAsActiveInactiveModal.isActive"
                @closeClicked="depotPricingMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>

    <manage-depot-products-modal
            :heading="depotManageProductsModal.heading"
            :showModal="depotManageProductsModal.showModal"
            :modalId="depotManageProductsModal.modalId"
            :isAdditionalProducts="true"
            @okClicked="onManageDepotProductsModalOkClicked"></manage-depot-products-modal>
    
    <modal-form
            :heading="updatePricingFormModal.heading"
            :modalId="updatePricingFormModal.modalId"
            :isSaving="updatePricingFormModal.isSaving"
            :showModal="updatePricingFormModal.showModal"
            @closeClicked="onUpdatePricingModalCloseClick"
            @saveButtonClicked="onUpdatePricingModalSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="priceInput">
                        New Price
                    </label>
                    <div class="text-danger">
                        {{updatePricingFormModal.depotProduct.priceErrorMessage}}
                    </div>
                    <currency-input class="form-control" v-model="updatePricingFormModal.depotProduct.price" 
                                    :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"></currency-input>
                    
                </div>
                <div class="form-group">
                    <label for="priceActiveDatePicker">
                        New Price Date Active
                    </label>
                    <div class="text-danger">
                        {{updatePricingFormModal.depotProduct.effectiveDateErrorMessage}}
                    </div>
                    <date-picker aria-describedby="newPriceActiveDateHelp" :format="'DD/MM/YYYY'" :elementId="'priceActiveDatePicker'" :date="updatePricingFormModal.depotProduct.activeFromDate"
                                 @dateChange="onNewPriceActiveFromSelected"></date-picker>
                    <small id="newPriceActiveDateHelp" class="form-text text-muted">
                        Enter the day new price will be active from
                    </small>
                </div>
            </form>
        </template>
    </modal-form>
</div>
